var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tables-list"},_vm._l((_vm.allTables),function(table){return _c('el-button',{key:table.id,class:table.status === 2 ? 'busy' : table.status === 1 ? 'free' : 'hold',on:{"click":function($event){return _vm.setTableToOrder(table)}}},[_vm._v(" "+_vm._s(table.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }